import { createSelector } from '@reduxjs/toolkit'
import { IAppState } from '../../../common/context/context'
import { selectSearchNeumaticosMoto } from './searchNeumaticosMoto.store'
import { MedidaNameMoto, OrderedMedidasMoto } from './medidasMoto.slice'

export const selectMedidasMoto = (state: IAppState) =>
  selectSearchNeumaticosMoto(state).medidas

export const selectSelectedMedidasMoto = (state: IAppState) =>
  selectSearchNeumaticosMoto(state).medidas.selectedMedidas

export const selectMedidasDataMoto = (state: IAppState) =>
  selectSearchNeumaticosMoto(state).medidas.medidasData

export const selectPreviousSelectedMedidasMoto = (state: IAppState) =>
  selectSearchNeumaticosMoto(state).medidas.previousSelectedMedidas

export const selectSelectedMedidasMotoSubtitle = createSelector(
  [selectSelectedMedidasMoto],
  (m) => {
    const { ancho, alto, llanta } = m ?? {}

    // Si falta qualsevol peça, no mostrem res
    if (
      ancho == null ||
      alto == null ||
      llanta == null
    ) {
      return ''
    }

    // Format: 285/40 R20 108V
    return `${ancho}/${alto} R${llanta}`
  }
)

export const selectHasAllMedidasMoto = createSelector(
  [selectSelectedMedidasMoto],
  (m) => {
    return (
      m.ancho != null &&
      m.alto != null &&
      m.llanta != null &&
      OrderedMedidasMoto.every((k) => m[k] != null)
    )
  }
)

export const selectIsMedidasConfirmedMoto = createSelector(
  [selectMedidasMoto],
  (m) => Boolean(m?.isMedidasConfirmed)
)

export const selectMedidasMotoSubtitle = createSelector(
  [selectSelectedMedidasMoto],
  (m) => {
    const { ancho, alto, llanta } = m ?? {}
    if (ancho == null || alto == null || llanta == null) return ''
    // Format example: "110/80-16"
    return `${ancho}/${alto} ${llanta}`
  }
)

export const selectSelectedMedidasMotoForQuery = createSelector(
  [selectSelectedMedidasMoto],
  (m) => m as { [k in MedidaNameMoto]?: string | number | null }
)
